import { useEffect } from "react";

interface Props {
  title?: string;
  description?: string;
}

const DEFAULT_TITLE = `MetOceanAtlas`;
const DEFAULT_DESCRIPTION = `MetOceanWorks' dedicated data portal enabling exploration and purchase of wind, wave, current and water level data through a clean, user-friendly interface.`;

export const Meta = ({ title = DEFAULT_TITLE, description = DEFAULT_DESCRIPTION }: Props) => {
  useEffect(() => {
    document.title = title;

    let tag = document.querySelector('meta[name="description"]');
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", "description");
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", description);
  }, [title, description]);

  return null;
};